import { Component } from '@angular/core';
import { AlertController, App, ModalController, NavController } from 'ionic-angular';
import { XpReportService } from "../../services/xp-report.service";
import { XpWorkorderService } from "../../services/xp-workorder.service";
import { ApiService } from "../../services/api.service";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { DatePipe } from "@angular/common";

import {TabsPage} from "../tabs/tabs";

import { ReportMeasurementPage } from "../report-measurement/report-measurement";
import { NewsModalPage } from "../news-modal/news-modal";
import { XpWorkordersPage } from "../xp-workorders/xp-workorders";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'page-xp-home',
  templateUrl: 'xp-home.html'
})
export class XpHomePage {

  busy = false;
  completed_workorders_count = 0;

  workorders: any[] = [];
  workordersLoading = 0;

  news: any[] = [];
  newsLoading = 0;

  notifications = [];

  constructor(
    public app: App,
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private datePipe: DatePipe,
    public apiService: ApiService,
    public reportService: XpReportService,
    public iab: InAppBrowser,
    public translate: TranslateService,
    public workorderService: XpWorkorderService
  ){}

  public goToReport(){
    let tabs = this.navCtrl.parent;
    tabs.select(1);
  }

  public goToWorkorder(workorder) {
    // Gym flow: just open the Entrenamientos tab. The old HVAC per-workorder
    // report stack is no longer reachable.
    let tabs = this.navCtrl.parent;
    tabs.select(1);
  }

  public goToNewWorkorder() {
    let tabs = this.navCtrl.parent;
    tabs.select(1).then(() => {
      setTimeout(() => {
        let page = tabs.getSelected().getActive().instance;
        if(page instanceof XpWorkordersPage){
          page.chooseNewWorkorderType();
        }
      }, 500);
    });
  }

  public goToSearchUnit(){
    let tabs = this.navCtrl.parent;
    tabs.select(2);
  }

  public goToCompanyFiles(){
    let tabs = this.navCtrl.parent;
    tabs.select(3);
  }

  public goToLogin(){
    this.reportService.setData({});
    this.workorderService.clearWorkorders().then(() => {
      this.app.getRootNavs()[0].setRoot(TabsPage);
    });
  }

  public goToTest(){
    this.navCtrl.push(ReportMeasurementPage, {
      data: {}
    });
  }

  public goToNews(){
    var modal = this.modalCtrl.create(NewsModalPage, {}, {
      enableBackdropDismiss: false,
      cssClass: 'modal-fullscreen'
    });
    modal.present();
  }

  ionViewDidEnter(){
    console.log('ionViewDidEnter XpHomePage');
    this.getWorkorders();
    this.loadNews();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad XpHomePage');
  }

  private sortByTimePlanned(a, b){
    let a_time_planned = a.time_planned ? parseInt(a.time_planned) : 0;
    let b_time_planned = b.time_planned ? parseInt(b.time_planned) : 0;
    if (a_time_planned > b_time_planned) return 1;
    if (b_time_planned > a_time_planned) return -1;
    return 0;
  }

  getWorkorders() {
    this.workordersLoading = 1;
    this.workorderService.getWorkorders().then((workorders: any) => {
      this.workordersLoading = 0;
      this.workorders = [];
      for(let workorder of workorders) {
        if(workorder._status !== 'done'){
          this.workorders.push(workorder);
        }
      }
      this.workorders = this.workorders.sort(this.sortByTimePlanned);
    }).catch((err) => {
      this.workordersLoading = -1;
      console.error(err);
    });
  }

  openNewsLink(record){
    if(record.link){
      this.iab.create(record.link, '_system');
    }
  }

  loadNews() {
    this.apiService.getNews().then((data: any) => {
      this.newsLoading = 0;
      this.news = data;
    }).catch((error) => {
      this.newsLoading = -1;
      console.error(error);
    });
  }

  getWorkorderTitle1(workorder){
    if(workorder.customers&& workorder.customers.client){
      if(workorder.customers.client.list_title){
        return (workorder.customers.client.list_title).trim();
      }
      if(workorder.customers.client.firstname || workorder.customers.client.lastname || workorder.customers.client.company){
        return (workorder.customers.client.firstname + ' ' + workorder.customers.client.lastname + ' ' + workorder.customers.client.company).trim();
      }
    }
    return this.translate.instant('Onbekende klant');
  }

  getWorkorderTitle2(workorder){
    if(workorder.location){
      let out= (((workorder.location.street ? workorder.location.street : '') + ' ' + (workorder.location.number ? workorder.location.number : '') + ' ' + (workorder.location.letter ? workorder.location.letter : '')).trim()
        + ' ' + (workorder.location.city ? workorder.location.city : '').trim()).trim();
      if(out){
        return out;
      }
    }
    return this.translate.instant('Onbekende locatie');
  }

  public deleteNotification(record){
    for(let i = 0; i < this.notifications.length; i++){
      if(this.notifications[i] === record){
        this.notifications.splice(i, 1);
      }
    }
  }

  getWorkorderUnitTitle(workorder){
    if(workorder._selected_units && workorder._selected_units.length > 0 && workorder._selected_units[0].list_subtitle){
      let unit = workorder._selected_units[0];
      return unit.list_title.trim();
    }
    return this.translate.instant('Geen installatie geselecteerd');
  }

  getDisplayTimePlanned(workorder){
    if(!workorder.time_planned){
      return '';
    }
    let date = new Date(workorder.time_planned * 1000);
    let out = this.datePipe.transform(date,  'dd-MM-yyyy');
    if(workorder.daypart && workorder.daypart.time_start && workorder.daypart.time_end){
      let time_start = workorder.daypart.time_start.substr(0,5);
      let time_end = workorder.daypart.time_end.substr(0,5);
      out += ' (' + time_start + '-' + time_end + ')';
    }
    return out;
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-home/xp-home.ts